import { Injectable } from '@angular/core';

declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  constructor() { }

  public hasPageV2Theme(): boolean {
    // const pageV2ThemAttribute = "data-enablev2theme";

    // let hasV2Theme = false;
    // if (this.getPageAttribute(pageV2ThemAttribute) === 'true')
    //   hasV2Theme = true;

    let hasV2Theme = true;
    return hasV2Theme;
  }

  public getPageAttribute(pageAttribute: string): string {
    return this.getHeaderElement().attr(pageAttribute) === 'true' ? 'true' : 'false'
  }

  public getHeaderElement() {
    const headerSelector = '.main-wrapper.www-wrapper';
    return $(headerSelector);
  }
}
